export class PositionsTab {
  public Controls: any = [];
  public ColumnNames: string[] = new Array<string>();
}
